import {type DeltaQueryTypeOverride} from '../types';

/**
 * Resolves the admin-only delta query override against the viewer's privileges.
 * A URL or saved value only takes effect for W&B admins on non-server
 * deployments; every other viewer (and every server deployment) resolves to
 * undefined, so a persisted or shared URL value can never affect query
 * selection for non-admins. The URL param wins over the panel-config value.
 */
export function resolveDeltaQueryTypeOverride(
  savedValue: DeltaQueryTypeOverride | undefined,
  viewerIsAdmin: boolean | null | undefined,
  isServerDeployment: boolean,
  urlValue?: DeltaQueryTypeOverride
): DeltaQueryTypeOverride | undefined {
  if (isServerDeployment || !viewerIsAdmin) {
    return undefined;
  }
  return urlValue ?? savedValue;
}
